<template>
<div id="app">
  <router-view></router-view>
  <v-snackbar
    :top="snackBar.y === 'top'"
    v-model="snackBar.snackbar">
      {{ snackBar.text }}
    <v-btn flat icon color="white" @click.native="snackBar.snackbar = false">
      <v-icon dark class="white--text">clear</v-icon>
    </v-btn>
  </v-snackbar>
</div>
</template>

<script>
import {
  mapGetters
} from 'vuex'

import Cookie from 'js-cookie';

export default {
  name: 'app',
  data() {
    return {
      snackBar: {
        snackbar: true,
        y: 'top',
        x: null,
        mode: '',
        text: 'Updated to ChEMBL 28'
      }
    }
  },
  beforeMount() {
    if (Cookie.get("prbTerms")) {
      this.$store.dispatch("VERIFY_TERMS")
    }
  },
  mounted() {
    let that = this

    setTimeout(function(){
      that.snackBar.snackbar = false
    }, 12000)
  }
}
</script>

<style>
#app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;
  background: white;
}
</style>



// WEBPACK FOOTER //
// App.vue?7c1f33e7